import ConfirmDeleteModalUI from '@/components/common/ConfirmDeleteModalUI/ConfirmDeleteModalUI'
import { debounce } from 'lodash'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useDeleteFlowRule from '../../hooks/hydraulic/flowRule/useDeleteFlowRule'
import useFlowRuleCascadeCheck from '../../hooks/hydraulic/useFlowRuleCascadeCheck'
import CascadeDeleteNotice from './CascadeDeleteNotice'
import useTranslation from '@/hooks/useTranslation'

interface DeleteModalProps {
  id?: string
  interfaceId?: string
  name?: string
}

const DeleteFlowRuleModal = ({ id, interfaceId, name }: DeleteModalProps) => {
  const { t } = useTranslation()
  const { closeModal } = useConfigUI()

  const { mutate: deleteModal, isLoading: loadingDeleteFlowRule } =
    useDeleteFlowRule()

  // Looked up before the user agrees, and handed to the delete, so what is
  // removed is exactly what the confirmation named. Read fresh on every
  // opening, and Confirm waits for it and for the water sources.
  const {
    children,
    childrenForDelete,
    loading: loadingChildren,
    blockReason,
  } = useFlowRuleCascadeCheck(interfaceId, id)

  const handleDeleteFlowRule = debounce(async () => {
    if (!id) return
    if (!interfaceId) return
    const blocked = blockReason()
    if (blocked) {
      toast.error(blocked)
      closeModal()
      return
    }
    deleteModal({ interfaceId, id, children: childrenForDelete })
  }, 300)

  return (
    <ConfirmDeleteModalUI
      title={t('DeleteFlowRule')}
      name={name}
      text={t('flowRuleDeleteConfirmation')}
      onClose={closeModal}
      onConfirm={handleDeleteFlowRule}
      isLoading={loadingDeleteFlowRule || loadingChildren}
    >
      <CascadeDeleteNotice children={children} isLoading={loadingChildren} />
    </ConfirmDeleteModalUI>
  )
}

export default DeleteFlowRuleModal
